import { render } from "./readonly.vue?vue&type=template&id=45610c09&scoped=true"
import script from "./readonly.vue?vue&type=script&lang=js"
export * from "./readonly.vue?vue&type=script&lang=js"

import "./readonly.vue?vue&type=style&index=0&id=45610c09&lang=less&scoped=true"

import exportComponent from "/Users/aa/work/credit_chakra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45610c09"]])

export default __exports__